// components/InvoiceNumberSettings.tsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { updateLocalStorageInvoiceNumber } from '../utils/invoiceHelper';

const InvoiceNumberSettings: React.FC = () => {
  const { t } = useTranslation();    
  const [currentNumber, setCurrentNumber] = useState<number>(1);
  const [inputValue, setInputValue] = useState('');


  useEffect(() => {
    const stored = localStorage.getItem('invoice_counter');
    setCurrentNumber(stored ? parseInt(stored, 10) : 0);
  }, []);

  const handleManualSet = () => {
    const parsed = parseInt(inputValue);
    if (!isNaN(parsed) && parsed >= 0) {
      updateLocalStorageInvoiceNumber(parsed)
      setCurrentNumber(parsed);
      alert(`${t('message.correctInvoiceId')}: ${parsed}`);
      setInputValue('');
    } else {
      alert(t('message.wrongInvoiceId'));
    }
  };

  return (
    <>
    <Row className="border p-3 rounded bg-white my-3">
        <h5>{t('invoiceNumberSetUp')}</h5>
        <p>{t('currentCounter')}: <strong>{currentNumber}</strong></p>
        <Col>
          <Form.Control placeholder={`${t('forExample')}: 25`} value={inputValue} type="number" name="to" className="my-2"
           onChange={(e) => setInputValue(e.target.value)}/>
        </Col>
        <Col>
            <Button className="btn btn-primary mt-1" onClick={handleManualSet} >{t('setUpNewNumber')}</Button>
        </Col>
    </Row>
    </>
    
  );
};

export default InvoiceNumberSettings;
